import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef7fe894"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "modal" }, null, -1))
const _hoisted_2 = { class: "flex m-auto main relative" }
const _hoisted_3 = { class: "flex-1 w-full relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSideNav = _resolveComponent("AppSideNav")!
  const _component_AppNav = _resolveComponent("AppNav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BuyLpModal = _resolveComponent("BuyLpModal")!
  const _component_BuyTokenModal = _resolveComponent("BuyTokenModal")!
  const _component_SwitchToBnbModal = _resolveComponent("SwitchToBnbModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppSideNav),
      _createElementVNode("main", _hoisted_3, [
        _createVNode(_component_AppNav, { class: "absolute top-0 w-full z-10" }),
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.path
        }))
      ])
    ]),
    (_ctx.isBuyLpModalVisible)
      ? (_openBlock(), _createBlock(_component_BuyLpModal, {
          key: 0,
          poolId: _ctx.poolId,
          isVisible: _ctx.isBuyLpModalVisible,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleBuyLpModal(false)))
        }, null, 8, ["poolId", "isVisible"]))
      : _createCommentVNode("", true),
    (_ctx.isBuyTokenModalVisible)
      ? (_openBlock(), _createBlock(_component_BuyTokenModal, {
          key: 1,
          isVisible: _ctx.isBuyTokenModalVisible,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleBuyTokenModal(false)))
        }, null, 8, ["isVisible"]))
      : _createCommentVNode("", true),
    (_ctx.isSwitchToBnbModalVisible)
      ? (_openBlock(), _createBlock(_component_SwitchToBnbModal, {
          key: 2,
          isVisible: _ctx.isSwitchToBnbModalVisible,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSwitchToBnbModal(false)))
        }, null, 8, ["isVisible"]))
      : _createCommentVNode("", true)
  ], 64))
}